/**
 * @file: TaskFlowType.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum TaskFlowType {
  PreInspection = 'pre-inspection',
  Inspection = 'inspection',
  InspectionFlow = 'inspection-flow',
  Construction = 'construction',
  ConstructionJob = 'construction-job',
  CompletionCheck = 'completion-check',
  SamplingCheck = 'sampling-check',
  Task = 'task',
}
